module.exports = __webpack_public_path__ + "assets/img/preview_02.e215938c.png";